import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OfferStatusEnum} from "@app/enums/offer-status.enum";
import {ModalContainerComponent} from "@app/modal/modal-container/modal-container.component";
import {PersonalOfferInterface, RedistributionRequestInterface} from "@app/redistribution/redistribution.interface";
import {DatePipe, NgIf} from "@angular/common";
import {
  RedistributionStatusComponent
} from "@app/redistribution/shared/redistribution-status/redistribution-status.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {catchError, filter, forkJoin, take, throwError} from "rxjs";
import {ToastService} from "@app/toast/toast.service";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: 'app-modal-manage-personal-proposal',
  templateUrl: './modal-manage-personal-proposal.component.html',
  styleUrls: ['./modal-manage-personal-proposal.component.scss'],
  standalone: true,
  imports: [
    ModalContainerComponent,
    NgIf,
    RedistributionStatusComponent,
    ReactiveFormsModule,
    LoadingAnimationComponent,
    DatePipe
  ]
})
export class ModalManagePersonalProposalComponent implements OnInit {
  isLoading = false;
  allOrganizations: any[] = [];
  destroyRef = inject(DestroyRef);
  
  canManageOffering = false;
  canCancelOffering = false;
  
  _redistributionRequest!: RedistributionRequestInterface;
  @Input()
  set redistributionRequest(data: RedistributionRequestInterface) {
    this._redistributionRequest = data;
    
    if (this.dataService.userOrganizationsValue.value.length > 0) {
      if (data) {
        this.canManageOffering = this.dataService.userOrganizationsValue.value.find(el => el['id'] === data.organizationId) !== undefined
      }
    } else {
      this.dataService.userOrganizationsValue
          .pipe(
              filter((val) => val.length > 0),
              take(1)
          )
          .subscribe((value) => {
            if (data) {
              this.canManageOffering = value.find(el => el['id'] === data.organizationId) !== undefined;
            }
          })
    }
  }
  get redistributionRequest(): RedistributionRequestInterface {
    return this._redistributionRequest
  }
  
  _personalOffer!: PersonalOfferInterface
  @Input()
  set personalOffer(data: PersonalOfferInterface) {
    this._personalOffer = data;
    if (data) {
      this.canCancelOffering = this.dataService.userOrganizationsValue.value.find(el => el['id'] === data.organizationId) !== undefined;
    }
  }
  get personalOffer(): PersonalOfferInterface {
    return this._personalOffer;
  }
  
  @Output() updateData = new EventEmitter<void>();
  @Output() onReject = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  
  @ViewChild('modalContainer') modalContainer!: ModalContainerComponent;
  
  constructor(
      private redistributionApiService: RedistributionApiService,
      private toastService: ToastService,
      private dataService: DataService,
  ) { }
  
  ngOnInit(): void {
    
    this.dataService.allOrganizationsValue.subscribe((value) => {
      let res = [];
      let stash = [...value.data];
      
      while (stash.length > 0) {
        let el = stash.pop();
        res.push(el);
        if (el.children.length > 0) {
          stash.push(...el.children);
        }
      }
      
      
      this.allOrganizations = res;
    })
  }
  
  open() {
    this.modalContainer.openModal()
  }
  
  close() {}
  
  accept() {
    this.isLoading = true;
    this.redistributionApiService.confirmPersonalProposal(this.personalOffer.id)
        .pipe(
            catchError((error) => {
              this.toastService.showError(error.error.messages[1]);
              this.isLoading = false;
              return throwError(() => error);
            })
        )
        .subscribe(() => {
          this.isLoading = false;
          this.updateData.emit();
          this.toastService.showSuccess('Запис успішно оновлено.');
          this.modalContainer.close();
        })
    
  }
  
  reject() {
    this.onReject.emit();
    this.modalContainer.close();
  }
  
  cancel() {
    this.onCancel.emit();
    this.modalContainer.close();
  }
  
  getOrganisationName(id: number) {
    return this.allOrganizations.find((el: { id: number; }) => el.id === id)?.fullName || id;
  }
  
  get isActiveOffering() {
    return this.personalOffer && this.personalOffer.status === 'ACTIVE';
  }

}
